import {ApolloClient, gql, NormalizedCacheObject} from "@apollo/client";

import {PieceStatuses} from "@/shared/constants";
import {PieceStatusMutation, PieceStatusMutationVariables} from "../types";

// Change the status of a piece
export default async function pieceStatusUpdate(
  client: ApolloClient<NormalizedCacheObject>,
  pieceId: number,
  status: PieceStatuses,
) {
  const result = await client.mutate<PieceStatusMutation, PieceStatusMutationVariables>({
    mutation: gql`
      mutation PieceStatusMutation($pieceId: Int!, $status: String!) {
        piece: update_pieces_by_pk(pk_columns: {id: $pieceId}, _set: {status: $status}) {
          id
          status
        }
      }
    `,
    variables: {pieceId, status},
  });
  const piece = result.data?.piece;
  if (!piece || piece.status !== status) throw new Error("Could not change the status of the Piece");
  return piece;
}
